import SVG from './svg';

export default () => {

    return (
        <div className="loader-overlay animate__animated ">
            {/* <img className="animate__animated animate__infinite animate__pulse xmas_logo" src={`${window.location.origin}/source/system/winter/logotype.png`} /> */}
            <SVG />
        </div>
    )
}